module.exports = __webpack_public_path__ + "img/1434087490.79d06cda.jpg";